import { useSelector } from 'react-redux';

export function useEventLocations(eventId) {
    return (
        useSelector((state) => state.events[eventId]?.locations.listed) || []
    );
}

export function useEventIndexedLocations(eventId) {
    return (
        useSelector((state) => state.events[eventId]?.locations.indexed) || {}
    );
}

export function useEventLocation(eventId, locationId) {
    const indexedLocations = useEventIndexedLocations(eventId);
    return indexedLocations[locationId];
}
